const filterOnlyShowableTabs = (tabs) => tabs.filter((_tab) => _tab.show === true || _tab.show == undefined);
const generateTabValues = (tabs) => tabs.map((_tab, index) => ({ ..._tab, value: index }));
const findActiveTabByCurrentTabValue = (currentTabValue, tabs) => tabs.find((_tab) => _tab.value === currentTabValue);

export default {
  methods: {
    getOnlyShowableTabs(tabs) {
      return generateTabValues(filterOnlyShowableTabs(tabs));
    },
    getActiveTab(currentTabValue, tabs) {
      return findActiveTabByCurrentTabValue(currentTabValue, tabs);
    },
    getActiveComponent(currentTabValue, tabs) {
      return findActiveTabByCurrentTabValue(currentTabValue, tabs)?.component;
    },
    getActiveProps(currentTabValue, tabs) {
      return findActiveTabByCurrentTabValue(currentTabValue, tabs)?.props;
    }
  },
}
